import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { BotService } from 'rainbow-web-sdk/services/bot/bot.service';
import { ConversationServiceRB } from 'rainbow-web-sdk/services/conversation/conversation.service';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { BubbleServiceRB } from 'rainbow-web-sdk/services/bubbles/bubble.service';
import { WebinarServiceRB } from 'rainbow-web-sdk/services/webinars/webinars.service';
import { PollsServiceRB } from '../services/polls/polls.service';

export class WebinarPlugin extends Plugin {
    public static initialize(): WebinarPlugin {
        Plugin.initialize();
        if (!window.rainbow.plugins[WebinarPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[WebinarPlugin] initialized");
            window.rainbow.plugins[WebinarPlugin.name] = new WebinarPlugin();

            BotService.getInstance();
            ConversationServiceRB.getInstance();
            BubbleServiceRB.getInstance();
            WebinarServiceRB.getInstance();
            PollsServiceRB.getInstance();
        }
        return window.rainbow.plugins[WebinarPlugin.name];
    }

    private constructor() { super(); }
}
